import React from 'react'
import Video from './Video'

const Events = ({ events }) => {
  return (
    <>
      {events != null && (
        <ul className="events">
          {events.map((e, index) => (
            <li className="event" key={index}>
              <span className="event-label">
                {e.time}
                {e.title != null && ` / ${e.title}`}
                {e.place != null && ` - ${e.place}`}
              </span>
              {e.link != null && e.link.text == null ? (
                <a href={e.link} target="_blank" rel="noreferrer">
                  {e.description}
                </a>
              ) : (
                <span>
                  {e.description}{' '}
                  {e.link != null && e.link.text != null && (
                    <a href={e.link.url}>{e.link.text}</a>
                  )}
                  {e.price != null && ` - ${e.price}`}
                </span>
              )}
              <div class="event-video">
                {e.video != null && <Video video={e.video} />}
              </div>
            </li>
          ))}
        </ul>
      )}
    </>
  )
}

export default Events
